import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Affix } from '@mantine/core';

const DevToolsLayout = () => (
  <>
    <Affix position={{ bottom: 72, left: 20 }}>
      <ReactQueryDevtools buttonPosition="relative" />
    </Affix>
    <TanStackRouterDevtools position="bottom-left" />
  </>
);

export default DevToolsLayout;
